module.exports = __webpack_public_path__ + "static/media/thps.866e5087.png";